export default __webpack_public_path__ + "static/media/Background_00132.32ed919a.png";